import onboardingCopyJson from '../../guidance/chat/onboarding.json'
import type { OnboardingCopy } from '../../../netlify/functions/lib/project-chat-types'

/**
 * All onboarding copy, from the `onboarding` guidance entry — still the sole source, just imported at
 * build time instead of fetched at run time.
 *
 * It used to come over the wire from /api/onboarding-copy, and OnboardingChat gated its entire render
 * on that response. Since guidance is repo source bundled at deploy time, the fetch bought no
 * freshness and cost every first-time visitor a wait on a cold, DB-connected Lambda (measured at
 * ~3.5s) staring at a "Setting up your new project flow" spinner — with no way out at all if the
 * request failed. Importing the same file removes the request, the wait, and the dead-end.
 */
export const ONBOARDING_COPY = onboardingCopyJson as OnboardingCopy
